import api from "../../api/index.js";

const state = {};

const getters = {};

const actions = {
  GetMemberAccessToken({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetMemberAccessToken",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetMemberInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetMemberInfo",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetUser",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  MemberPost({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/Member/Post",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetPosterQRcode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetPosterQRcode",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetAgent({commit},payload){
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetAgent",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetIsRelease({commit},payload)
  {
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetIsRelease",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetMemberOrderIntegralSearch({ commit }, payload){
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetMemberOrderIntegralSearch",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetTeamSumCommissionSearch({ commit }, payload){
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetTeamSumCommissionSearch",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetMemberTeamPrice({ commit }, payload){
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetMemberTeamPrice",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },

};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/member.js